module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"သုခမိန်လေး","short_name":"သုခမိန်လေး","description":"မှန်မှန်ပြောမယ့် မောင်မှန်ကြီး","start_url":"/","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"93eadc9fc24b4f0ee6980ccff5a33464"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
